import { FundCentreState, RequestPayloadAssets } from '@/store/fundCentre/typings';
import { PayloadAction } from '@reduxjs/toolkit';
import {
  FundCentreOverviewDataBridgeResponse,
  FundCentrePricesDataBridgeResponse,
} from 'model/ApiGateway';

export const setFundDetailsData = {
  setFundDetailsPageUrl(state: FundCentreState, { payload }: PayloadAction<any>) {
    state.fundDetailsPageUrl = payload;
  },
  setActiveTab(state: FundCentreState, { payload }: PayloadAction<number>) {
    state.activeTabKey = payload;
  },
  setCurrentPage(state: FundCentreState, { payload }: PayloadAction<number>) {
    state.currentPage = payload;
  },
  setSelectedTab(state: FundCentreState, { payload }: PayloadAction<string>) {
    state.selectedTab = payload;
  },
  setRequestPayloadAssets(
    state: FundCentreState,
    { payload }: PayloadAction<RequestPayloadAssets>
  ) {
    state.requestPayloadAssets = { ...state.requestPayloadAssets, ...payload };
  },
  setShareclassMappings(state: FundCentreState, { payload }: PayloadAction<any>) {
    state.shareclassMappings = payload;
  },
  setSearchQuery(state: FundCentreState, { payload }: PayloadAction<{ id: string; name: string }>) {
    state.searchQuery.id = payload.id;
    state.searchQuery.name = payload.name;
  },
  setSearchByISIN(state: FundCentreState, { payload }: PayloadAction<boolean>) {
    state.searchByISIN = payload;
  },
  setSearchByISINResult(state: FundCentreState, { payload }: PayloadAction<{ id: string }>) {
    state.searchByISINResult = payload;
  },
  setPaginationData(
    state: FundCentreState,
    { payload }: PayloadAction<{ take: number; skip: number }>
  ) {
    state.paginationData.take = payload.take;
    state.paginationData.skip = payload.skip;
  },
  updateSelectedShareclass(
    state: FundCentreState,
    { payload }: PayloadAction<{ fundIdx: number; shareclassID: string }>
  ) {
    const fund = state.funds[payload.fundIdx];
    const selected = fund.shareclasses?.find(
      (shareclass) => shareclass.shareclassID === payload.shareclassID
    );
    if (selected) {
      fund.selectedShareclass = selected;
    }
  },
  setFilters(state: FundCentreState, { payload }: PayloadAction<any>) {
    state.appliedFilters = payload;
  },
  setSelectedDate(state: FundCentreState, { payload }: PayloadAction<string | null>) {
    state.selectedDate = payload;
  },
  setFundsData(
    state: FundCentreState,
    {
      payload,
    }: PayloadAction<FundCentreOverviewDataBridgeResponse | FundCentrePricesDataBridgeResponse>
  ) {
    const apiRes = payload.content;
    if (!apiRes) return;
    state.paginationMaxPages = (apiRes.lastPageNumber ?? 0) + 1;
    if (state.activeTabKey === 0) {
      state.allFundsCount = apiRes.resultCount ?? 0;
    }
    if (state.activeTabKey === 1) {
      state.fundsInFocusCount = apiRes.resultCount ?? 0;
    }
    // nav tab represent the same API endpoint as prices but have different tab name and fields
    const funds = ('prices' in apiRes ? apiRes.prices : apiRes.overview) ?? [];
    // const funds: Funds[] =
    //   state.selectedTab === 'navs' ? apiRes.prices : apiRes[state.selectedTab] || apiRes.overview;
    state.funds = funds.map((fund) => {
      const selectedShareclass =
        fund.shareclasses?.find((shareClass) =>
          shareClass.shareclassName?.startsWith(
            state.shareclassMappings[fund.correlationFundRangeId ?? '']
          )
        ) || fund.shareclasses?.[0];

      return {
        ...fund,
        selectedShareclass,
      };
    });
  },
};
